export class Direction {

    id: number|undefined;
    active: boolean;
    code: string;
    label:string;
  
  }